import { KeyboardEvent, SyntheticEvent, useEffect, useState } from 'react';
import { useAppDispatch } from '../../../hooks';
import { login } from '../../../store/slices';
import { ILoginApi } from '../../../types';
import { PrimaryButton, PrimaryInput } from '../../components/shared';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [payload, setPayload] = useState<ILoginApi>({
    username: '',
    password: '',
  });

  const [required, setRequired] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const _handleLogin = (e?: SyntheticEvent<HTMLFormElement>) => {
    e?.preventDefault();
    if (!required) return;
    setLoading(true);
    dispatch(login(payload)).finally(() => setLoading(false));
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      _handleLogin();
    }
  };

  const onGetInputValue = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    const name = event.currentTarget.name;

    setPayload({ ...payload, [name]: value });
  };

  useEffect(() => {
    const { username, password } = payload;
    setRequired(username.length > 0 && password.length > 0);
  }, [payload]);

  return (
    <div className="h-screen bg-neutral-200 flex items-center justify-center">
      <form
        className="flex flex-col items-stretch bg-white rounded-2xl w-full max-w-md p-10 shadow-lg"
        onSubmit={_handleLogin}
      >
        <h1 className="text-neutral-800 bold text-center text-2xl mt-4">
          Welcome back
        </h1>
        <p className="text-neutral-500 text-center text-sm mt-2">
          Login to your account to continue
        </p>

        <PrimaryInput
          name="username"
          label="Username"
          className="w-full"
          onKeyDown={handleKeyDown}
          onChange={onGetInputValue}
          placeholder="Enter username"
        />
        <PrimaryInput
          password
          type="password"
          name="password"
          label="Password"
          className="w-full"
          onKeyDown={handleKeyDown}
          onChange={onGetInputValue}
          placeholder="Enter password"
        />

        <PrimaryButton
          disabled={!required || loading}
          loading={loading}
          text="Login"
          type="submit"
          classNames="mt-8 medium"
        />

        <span className="text-center">
          <button
            type="button"
            onClick={() => navigate('/auth/forgot-password')}
            className="mt-5 text-primary medium focus:outline-none"
          >
            Forgot Password?
          </button>
        </span>
      </form>
    </div>
  );
};

export default Login;
